module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/104-ecuador-4a42dc5bbd4122f5663f8a2a31228f7b.svg";